import React from "react";
import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

import { BORDERRADIUS as borderRadius } from "@fedsim/constants";

export const SpacedPaper = styled((props) => <Paper {...props}
elevation={3} />)(
  ({ theme, dark = false, sx = {} }) => ({
    ...sx,
    padding: theme.spacing(1),
    backgroundColor: dark
      ? "rgb(25 25 25 / 8%)"
      : "rgb(167 167 167 / 80%)",
    borderRadius,
    backdropFilter: `blur(20px)`,
    height: "100%"
  })
);

export default SpacedPaper;
